import React, { useState, useEffect } from "react";
import { Typography, Grid, Button } from "@material-ui/core";
import {
  ListarVisitas,
  loadAccountListAll,
  ListarVisitasCliente,
  ListarVisitasClientexFecha,
  ListarVisitasxFecha,
} from "../utils/Actions";
import { GRID_DEFAULT_LOCALE_TEXT } from "../config/localeDatagrid";
import { Loading } from "../atoms";
import PersonPinCircle from "@material-ui/icons/PersonPinCircle";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@material-ui/data-grid";
import moment from "moment/min/moment-with-locales";
import { Link } from "react-router-dom";
import VisibilityIcon from "@material-ui/icons/Visibility";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import ApartmentIcon from "@material-ui/icons/Apartment";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import SearchIcon from "@material-ui/icons/Search";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import CachedIcon from "@material-ui/icons/Cached";
import DateRangeIcon from "@material-ui/icons/DateRange";
moment.locale("es");

export default function Visits() {
  const [state, setstate] = useState([]);
  const [visible, setVisible] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const account = localStorage.getItem("Account");
  const accountJSON = JSON.parse(account);
  const { rol, accountAsigned, accountAsignedName } = accountJSON[0];
  console.log(accountJSON);

  useEffect(() => {
    (async () => {
      await cargarDatos();
    })();
  }, []);

  const cargarDatos = async () => {
    if (startDate <= endDate) {
      let fechaini = new Date();
      let fechafin = new Date();
      fechaini = startDate;
      fechafin = new Date(endDate);
      fechaini.setHours(0, 0, 0, 0);
      fechafin.setHours(24, 0, 0, 0);
      if (rol === 4) {
        console.log("ACCOUNT ASSSINGED" + accountAsigned);
        setstate(
          (await ListarVisitasClientexFecha(accountAsigned, fechaini, fechafin))
            .data
        );
      } else {
        setstate((await ListarVisitasxFecha(fechaini, fechafin)).data);
      }
    } else {
      alert("La fecha inicial no puede ser mayor a la fecha final.");
    }
  };

  const cleanData = async () => {
    let fechaini = new Date();
    let fechafin = new Date();
    fechaini.setHours(0, 0, 0, 0);
    fechafin.setHours(24, 0, 0, 0);
    if (rol === 4) {
      console.log("ACCOUNT ASSSINGED" + accountAsigned);
      setstate(
        (await ListarVisitasClientexFecha(accountAsigned, fechaini, fechafin))
          .data
      );
    } else {
      setstate((await ListarVisitasxFecha(fechaini, fechafin)).data);
    }
  };

  const ExportCSV = ({ csvData, fileName }) => {
    let datauserexport = [];

    csvData.map((item) => {
      const data = {
        IDVISITA: item.id,
        CUENTA: item.account,
        NOMBRE: item.name,
        FECHA_ENTRADA: item.createdAt,
        FECHA_SALIDA: getUpdate(item.updatedAt),
        FOTO_PLACA: item.photoplaca,
        FOTO_IDENTIFICACION: item.photoid,
        TIPO: item.typedescription,
        IDENTIFICACION: item.identification,
        PLACA: item.idvehicule,
        MODELO: item.vehiculemodel,
        APARTAMENTO: item.aparment,
        PISO: item.floor,
        TEMPERATURE: item.temperature,
        ESTATUSSALIDA: item.statusexit ? "Salida Confirmada" : "Pendiente",
      };
      datauserexport.push(data);
    });

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const exportToCSV = (csvData, fileName) => {
      const ws = XLSX.utils.json_to_sheet(datauserexport);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    };

    return (
      <Button
        variant="outlined"
        color="secondary"
        onClick={(e) => exportToCSV(csvData, fileName)}
      >
        Exportar a Excel
      </Button>
    );
  };

  const buscarxfecha = async () => {
    await cargarDatos();
  };

  const cleanfilter = async () => {
    setStartDate(new Date());
    setEndDate(new Date());
    await cleanData();
  };

  const columns = [
    rol !== 4 && {
      field: "account",
      headerName: "Cuenta",
      renderCell: (params) => <Typography> {params.value}</Typography>,
      width: 200,
    },
    {
      field: "name",
      headerName: "Nombre",
      width: 200,
    },
    {
      field: "createdAt",
      headerName: "Entrada",
      width: 200,
      renderCell: (params) => <Typography> {params.value} </Typography>,
    },

    {
      field: "updatedAt",
      headerName: "Salida",
      width: 200,
      renderCell: (params) => (
        <Typography>{getUpdate(params.value)}</Typography>
      ),
    },
    {
      field: "Apartamento",
      headerName: "Apartamento",
      valueGetter: (params) =>
        `Piso ${params.getValue("floor") || ""} Apart. ${
          params.getValue("aparment") || ""
        }`,
      width: 200,
    },
    {
      field: "vehicule",
      headerName: "Vehículo",
      width: 150,

      valueGetter: (params) =>
        ` ${params.getValue("vehiculemodel") || ""}  ${
          params.getValue("idvehicule") || ""
        }`,
    },

    {
      field: "typedescription",
      headerName: "Tipo",
      width: 150,

      renderCell: (params) => <Typography>{params.value}</Typography>,
    },

    {
      field: "motivo",
      headerName: "Motivo",
      width: 150,

      renderCell: (params) => <Typography>{params.value}</Typography>,
    },
    {
      field: "id",
      headerName: "Acciones",
      width: 120,
      renderCell: (params) => (
        <Link
          to={{
            pathname: `/visitdetails?id=${params.value}`,
            state: { id: params.value },
          }}
        >
          <VisibilityIcon style={{ fontSize: 25 }} color="primary" />
        </Link>
      ),
      sortable: false,
    },
  ];

  const getUpdate = (fecha) => {
    let response = "";
    if (new Date(fecha).getFullYear() < 2000) {
      response = "-";
    } else {
      response = fecha;
    }
    return response;
  };

  const getVisitType = (type) => {
    switch (type) {
      case 1:
        return "Visita";
      case 2:
        return "Domestica";
      case 3:
        return "Delivery";
      case 4:
        return "Staff";
      case 5:
        return "Proveedores";
      default:
        return "Visita";
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer style={{ justifyContent: "flex-end" }}>
        <ExportCSV csvData={state} fileName={"Visitas"} />
      </GridToolbarContainer>
    );
  }

  const HeaderFilter = () => {
    return (
      <Grid
        direction="row"
        spacing={0}
        style={{ marginBottom: 20 }}
        container
        justify="space-around"
        alignItems="center"
      >
        <div style={{ display: "inline", alignItems: "center" }}>
          <Typography
            style={{
              fontWeight: "bold",
              alignItems: "center",
              marginBottom: 5,
              paddingTop: 5,
              fontSize: 16,
            }}
          >
            {" "}
            <DateRangeIcon
              style={{
                fontSize: 17,
              }}
            />
            Fecha Inicial
          </Typography>

          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            startDate={startDate}
            endDate={endDate}
          />
        </div>
        <div style={{ display: "inline" }}>
          <Typography
            style={{
              fontWeight: "bold",
              alignItems: "center",
              marginBottom: 5,
              paddingTop: 5,
              fontSize: 16,
            }}
          >
            <DateRangeIcon
              style={{
                fontSize: 17,
              }}
            />
            Fecha Final
          </Typography>
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
          />
        </div>
        <Button
          variant="contained"
          color="secondary"
          onClick={(e) => buscarxfecha()}
          startIcon={<SearchIcon />}
        >
          Buscar
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={(e) => cleanfilter()}
          startIcon={<CachedIcon />}
          style={{ color: "#fff" }}
        >
          Limpiar
        </Button>
      </Grid>
    );
  };

  return (
    <Grid
      container
      direction="column"
      style={{ height: "100vh", backgroundColor: "#fff", borderRadius: 5 }}
    >
      <Typography
        variant="h5"
        style={{
          marginBottom: 30,
          backgroundColor: "#fff",
          padding: 10,
          marginLeft: "auto",
          marginRight: "auto",
          borderRadius: 5,
        }}
      >
        <PersonPinCircle />
        Bitácora de Visitas{" "}
      </Typography>
      {rol === 4 && (
        <Typography variant="h6" style={{ marginBottom: 10, marginLeft: 20 }}>
          <ApartmentIcon style={{ alignSelf: "center", fontSize: 24 }} />

          {accountAsignedName}
        </Typography>
      )}

      <HeaderFilter />

      {state && (
        <DataGrid
          rows={state}
          columns={columns}
          autoPageSize={true}
          localeText={GRID_DEFAULT_LOCALE_TEXT}
          components={{
            Toolbar: CustomToolbar,
          }}
        />
      )}

      <Loading visible={visible} setVisible={setVisible} />
    </Grid>
  );
}
